import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/next/app/(tabs)/@modal/[lang]/qna/[id]/qna.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/react-native-web/dist/exports/AccessibilityInfo/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/react-native-web/dist/exports/ActivityIndicator/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/react-native-web/dist/exports/Animated/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/react-native-web/dist/exports/Appearance/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/react-native-web/dist/exports/AppRegistry/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/react-native-web/dist/exports/AppState/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/react-native-web/dist/exports/Clipboard/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/react-native-web/dist/exports/createElement/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-native-web/dist/exports/Dimensions/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-native-web/dist/exports/Image/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/react-native-web/dist/exports/KeyboardAvoidingView/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/react-native-web/dist/exports/Modal/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/react-native-web/dist/exports/Pressable/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/react-native-web/dist/exports/render/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/react-native-web/dist/exports/ScrollView/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-native-web/dist/exports/Text/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/react-native-web/dist/exports/TextInput/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/react-native-web/dist/exports/useColorScheme/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/react-native-web/dist/exports/useLocaleContext/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/react-native-web/dist/exports/useWindowDimensions/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-native-web/dist/exports/View/index.js");
;
import(/* webpackMode: "eager" */ "/app/packages/nc-nk-core/src/common/scriptBound.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/nc-nk-core/src/common/timeBound.tsx");
